import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';
import Result from '../Result';
import { getAppUrl } from 'fe-appdir-data-app';

const PROP_TYPES = {
  heading: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(PropTypes.object).isRequired,
  maxResults: PropTypes.number,
  onResultClick: PropTypes.func,
  gaResultClickCallback: PropTypes.func,
};

const DEFAULT_PROPS = {
  maxResults: Infinity,
};

const Wrapper = styled.div`
  width: 100%
  display: inline-block;
  font-family: ${theme.fontFamilyPrimary};

  @media (min-width: ${theme.breakpointSm}) {
    padding-bottom: ${theme.spacingMd};
  }
`;

const H4 = styled.h4`
  margin: 0px;
  padding: ${theme.spacingSm} ${theme.spacingXl};
  font-size: ${theme.fontSizeXxl};
  font-weight: ${theme.fontWeightBold};

  @media (max-width: ${theme.breakpointSm}) {
    padding: ${theme.spacingMd} ${theme.spacingXxl};
  }
`;

const Section = ({
  heading,
  results,
  maxResults,
  onResultClick,
  gaResultClickCallback,
}) => (
  <Wrapper>
    <H4>{heading}</H4>
    {results.map((result, index) => {
      if (index > maxResults - 1) return null;
      return (
        <Result
          key={result.id}
          name={result.name}
          body={result.shortDescription}
          imgSrc={result.iconUrl}
          url={getAppUrl(result)}
          slug={result.slug}
          onClick={onResultClick}
          gaResultClickCallback={gaResultClickCallback}
        />
      );
    })}
  </Wrapper>
);

Section.propTypes = PROP_TYPES;
Section.defaultProps = DEFAULT_PROPS;
Section.displayName = 'Section';

export default Section;
